import { useProductsCatalogV2Query } from '../gql/generated/graphql';

export const useProductsCatalog = () => {
  const { data, loading, error, refetch } = useProductsCatalogV2Query();

  const products = data?.productsCatalogV2 ?? [];

  return { products, loading, error, refetch };
};
